export function downloadBlob(res, fallbackName = "download") {
  const cd = res.headers?.["content-disposition"] || "";
  const m = /filename="?([^";]+)"?/.exec(cd);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = m ? m[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
